var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bb-box',{staticClass:"box-with-icon text-center",attrs:{"thin":""}},[(_vm.icon)?_c('div',{staticClass:"box-with-icon__icon"},[_c('bb-icon',{attrs:{"fill":"original","size":"fluid","name":_vm.icon}})],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }